import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { UploadManagerProvider } from "@/context/UploadManagerContext";
import { GroupPortraitUploadProvider } from "@/context/GroupPortraitUploadContext";
import LoginPage from "@/components/LoginPage";
import JobsPage from "@/components/JobsPage";
import JobDetailPage from "@/components/JobDetailPage";
import AdminUsersPage from "@/components/AdminUsersPage";
import AdminAuditPage from "@/components/AdminAuditPage";
import UploadPage from "@/components/UploadPage";
import AnalysisDashboard from "@/components/AnalysisDashboard";
import JobReviewPage from "@/components/JobReviewPage";
import FloatingUploadDock from "@/components/FloatingUploadDock";
import GroupPortraitTasksPage from "@/components/GroupPortraitTasksPage";
import PreschoolToolPage from "@/components/PreschoolToolPage";
import { PreschoolUploadProvider } from "@/context/PreschoolUploadContext";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    // checking session
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-sm text-slate-500 font-medium">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <UploadManagerProvider>
            <GroupPortraitUploadProvider>
            <PreschoolUploadProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={<ProtectedRoute><JobsPage /></ProtectedRoute>}
              />
              <Route
                path="/jobs/:jobId"
                element={<ProtectedRoute><JobDetailPage /></ProtectedRoute>}
              />
              <Route
                path="/jobs/:jobId/review"
                element={<ProtectedRoute adminOnly><JobReviewPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/users"
                element={<ProtectedRoute adminOnly><AdminUsersPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/audit"
                element={<ProtectedRoute adminOnly><AdminAuditPage /></ProtectedRoute>}
              />
              {/* Legacy photo-analyzer routes — accessible to authed users */}
              <Route
                path="/analyzer"
                element={<ProtectedRoute><UploadPage /></ProtectedRoute>}
              />
              <Route
                path="/session/:sessionId"
                element={<ProtectedRoute><AnalysisDashboard /></ProtectedRoute>}
              />
              <Route
                path="/group-portrait-tasks"
                element={<ProtectedRoute><GroupPortraitTasksPage /></ProtectedRoute>}
              />
              <Route
                path="/preschool-tool"
                element={<ProtectedRoute><PreschoolToolPage /></ProtectedRoute>}
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <FloatingUploadDock />
            </PreschoolUploadProvider>
            </GroupPortraitUploadProvider>
          </UploadManagerProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
